// Content
export const STORE_RESULTS = 'STORE_RESULTS';
export const STORE_REG = 'STORE_REG';
export const STORE_ENV_URL = 'STORE_ENV_URL';
export const STORE_ENV_TOKEN = 'STORE_ENV_TOKEN';
export const STORE_SELECTED = 'STORE_SELECTED';



// WEBPACK FOOTER //
// ./src/actions/types.js